module.exports = __webpack_public_path__ + "static/img/port (3).b9d59256.png";